"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyWindow = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyWindow(factory, src, size) {
    if (size <= 0) {
        throw new Error('size must be greater than 0.');
    }
    function* generator() {
        const arr = Array.isArray(src) ? src : [...src];
        for (let i = 0; i <= arr.length - size; i++) {
            const window = [];
            for (let j = i; j < i + size; j++) {
                window.push(arr[j]);
            }
            if (window.length === size) {
                yield factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(window), window);
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyWindow = applyWindow;
//# sourceMappingURL=applyWindow.js.map